export enum DiscoveryAreaItemType {
  TAG = 1,
  LINK = 2
}

export enum DiscoveryAreaConfigType {
  COURSE_DISCOVERY = 1,
  RENTAL_DISCOVERY = 2,
  ACTIVITY_DISCOVERY = 3,
  OVERVIEW_DISCOVERY = 4
}

export type DiscoveryAreaUpliftedItem = {
  type: DiscoveryAreaItemType
  imageUrl: string
  id?: number
  url?: string
} & DiscoveryAreaLanguages

export type DiscoveryUpliftedArea = {
  items: DiscoveryAreaUpliftedItem[]
} & DiscoveryAreaLanguages

export type DiscoveryTagGroup = {
  levels?: number[]
  targetTagIds?: number[]
} & DiscoveryAreaLanguages

export type DiscoveryAreaConfigWebOption = {
  type: DiscoveryAreaConfigType
  upliftedAreaSets: DiscoveryUpliftedArea[]
  tagGroups: DiscoveryTagGroup[]
} & DiscoveryAreaLanguages

interface DiscoveryAreaLanguages {
  title_en?: string
  title_nl?: string
  title_de?: string
  title_fr?: string
}
